import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useSocketClient } from "../../../contexts/SocketClientProvider";
import moment from "moment/min/moment-with-locales";
import ToggleIcon from "../../../Components/ToggleIcon";
import useControlAttribute from "../../../hooks/useControlAttribute";
import {
  TComfoair350MaintenanceAttribute,
  TBiolytMaintenanceAttribute,
  IControlBase,
} from "../types";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../contexts/LanguageProvider";

export type TMaintenanceItem = {
  name: string;
  attribute: TComfoair350MaintenanceAttribute | TBiolytMaintenanceAttribute;
};

interface IMaintenanceRowProps {
  control: IControlBase;
  item: TMaintenanceItem;
  reset: boolean;
}

const MaintenanceRow = (props: IMaintenanceRowProps) => {
  const { control, item, reset } = props;
  const { language } = useLanguage();
  const { t } = useTranslation();

  const socketClient = useSocketClient();
  const resetFilter = () => {
    socketClient.update_attribute({
      type: "control",
      id: control.id,
      attribute: item.attribute,
      value: moment().format(),
    });
  };

  moment.locale(language);
  const value = moment(useControlAttribute(control, item.attribute)).fromNow();
  return (
    <TableRow>
      <TableCell>{t(item.name)}</TableCell>
      <TableCell align="center">{value}</TableCell>
      {reset && (
        <TableCell align="center">
          <ToggleIcon name={"refresh"} onClick={resetFilter} />
        </TableCell>
      )}
    </TableRow>
  );
};

interface IMaintenanceTableProps {
  control: IControlBase;
  items: TMaintenanceItem[];
  reset: boolean;
}

const MaintenanceTable = (props: IMaintenanceTableProps) => {
  const { control, items, reset } = props;
  const { t } = useTranslation();
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontSize: 16 }}>{t("Maintenance")}</TableCell>
            <TableCell sx={{ fontSize: 16 }} align="center">
              {t("Last time")}
            </TableCell>
            {reset && (
              <TableCell sx={{ fontSize: 16 }} align="center">
                {t("Reset")}
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item, index) => (
            <MaintenanceRow
              key={index}
              control={control}
              item={item}
              reset={reset}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MaintenanceTable;
